import { Box, Button, Modal, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import "./SuccessModal.scss";

export default function SuccessModal({
	open,
	onClose,
}: {
	open: boolean;
	onClose: () => void;
}) {
	const navigator = useNavigate();

	return (
		<Modal
			open={open}
			onClose={onClose}
		>
			<Box className="form__success">
				<Box className="form__success__header">
					<Typography>
						🎉¡Gracias por
						<br />
						compartir tu idea!
					</Typography>
				</Box>
				<Box className="form__success__body">
					<Typography>
						Tu propuesta ha sido enviada con éxito.
						<br />
						Muy pronto el equipo la revisará y te
						<br />
						mantendremos al tanto de los próximos pasos.
					</Typography>

					<Button
						onClick={() => {
							onClose();
							navigator(-1);
						}}
					>
						Cerrar
					</Button>
				</Box>
			</Box>
		</Modal>
	);
}
